import axios from 'axios';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { SlArrowLeft } from 'react-icons/sl';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../insightConfig/insightConfig';
import ResultPreview1 from '../ResultPreview/ResultPreview1';
import "../TestStartComponent/teststart.css";
import YoutubeModal from '../YoutubeModal/YoutubeModal';

function Finalresult() {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const testData = location?.state?.testData;
    const currentTestSeriesTitleURL = JSON.parse(localStorage.getItem("CurrentTestSeriesTitleURL"));
    console.log(testData);
    // const [testData, setTestData] = useState({})
    const [testReport, setTestreport] = useState({})
    const navigate = useNavigate()
    const { totalquestion, correct, wrongquestions, notVisitedQuestions, allIndiaRank, testcorrectmarks, testwrongmarks } = testReport


    // override the browser's back button behavior for this particular page
    useEffect(() => {
        const handlePopState = (event) => {
            if (location.pathname === "/testseries/finalresult") {
                navigate("/testseries/" + currentTestSeriesTitleURL, { replace: true });
            }
        };

        window.addEventListener("popstate", handlePopState);
    }, []);



    useEffect(() => {
        axios.get(BASE_URL + `/get-test-report/${testData.testSeriesSn}/${testData.PackageID}`).then((respnse) => {
            setTestreport(respnse.data.report)
        }).catch(error => {
            console.error("Error fetching test report:", error);
        })
    }, [])

    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };



    return (
        <>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-3 test-background p-3 pt-1'>
                        <button onClick={() => navigate('/testseries/' + currentTestSeriesTitleURL)} className='btn btn-sm btn-info mb-3'><SlArrowLeft /> Back</button>
                        <div className='d-grid gap-3'>
                            <button type="button" className="btn bg-darkblue btn-md py-3 d-md-none">
                                {testData?.Type === "MCQ" ? <>PTS-{testData.AccessCode}</> : <>MTS-{testData.AccessCode}</>} : {testData.Title}
                                <hr className='my-1' />
                                {testData.QuestionCount} Ques | {testData.Duration} min | {testData.MarksTotal} marks
                            </button>
                            <button type="button" className="btn bg-darkorange btn-md py-3">RESULT</button>
                            <Link to="/TestResultDetailView" state={{ testReport, testData }} type="button" className="btn bg-darkorange btn-md py-3">VIEW REPORT</Link>
                            <button type="button" className="btn bg-darkorange btn-md py-3" onClick={() => window.open(testData?.ModelAnswerPDF, '_blank')}>EXPLANATION</button>
                            {testData?.VideoUrl != '' && testData.VideoUrl != 'N' && <button type="button" onClick={openModal} className="btn bg-darkgreen btn-md p-3">VIDEO DISCUSSION</button>}
                        </div>
                    </div>
                    <div className='col-lg-9 teststart-padding'>

                        <div className='container-fluid  d-none d-md-block'>
                            <div className='row'>
                                <button type="button" className="btn bg-darkblue btn-md py-3">
                                    {testData?.Type === "MCQ" ? <>PTS-{testData.AccessCode}</> : <>MTS-{testData.AccessCode}</>} : {testData.Title}
                                    <hr className='my-1' />
                                    {testData.QuestionCount} Ques | {testData.Duration} min | {testData.MarksTotal} marks
                                </button>
                            </div>
                        </div>
                        <ResultPreview1 totalQuestions={totalquestion} correctQuestions={correct} wrongQuestions={wrongquestions} correctMarks={testcorrectmarks} wrongMarks={testwrongmarks} notVisitedQuestions={notVisitedQuestions} />
                    </div>
                </div>
            </div>
            <Modal show={isOpen} centered className="animate__animated animate__fadeIn mobileyoutube">
                <YoutubeModal closeModal={closeModal} VideoId={testData.VideoUrl} />
            </Modal>
        </>
    )
}

export default Finalresult;
